import { useEffect, useState } from "react";
import { MenuItem } from "@mui/material";
import { t } from "i18next";
import ApiUrls from "../../helpers/urls/ApiUrls";
import api from "../../helpers/api/Api";
import { setSiteList } from "../../redux/actions";
import { connect } from "react-redux";
import SelectCustom from "../SelectCustom";

function SiteSelect({ value, onChange, error, hasAll, setSiteList }) {
  const [sites, setSites] = useState([]);
  const [sitesLoading, setSitesLoading] = useState(true);

  useEffect(() => {
    getSitesList();
  }, []);

  const getSitesList = () => {
    api.post(ApiUrls.site.list, {})
      .then((response) => {
        setSites(response.data.data);
        setSiteList(response.data.data);
        setSitesLoading(false);
      })
      .catch((error) => {
        setSitesLoading(false);
      });
  }

  return (
    <SelectCustom
      id="site-select"
      value={value}
      error={error}
      label={t("site.site")}
      onChange={onChange}
      loading={sitesLoading}
    >
      {hasAll
        ? <MenuItem value={"all"} key={"all"}>{t("global.all")}</MenuItem>
        : null
      }
      {sites.map((site, i) => {
        return <MenuItem value={site.mgmtip} key={i}>{site.name}</MenuItem>
      })}
    </SelectCustom>
  );
}

const mapDispatchToProps = dispatch => {
  return {
    setSiteList: data => dispatch(setSiteList(data))
  }
}

export default connect(null, mapDispatchToProps)(SiteSelect);
